<template>
  <page-header-wrapper>
    <a-card>
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商户号">
                <a-input v-model="queryParams.mchId" placeholder="请输入微信商户号" allow-clear @pressEnter="handleQuery" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商户名称">
                <a-input v-model="queryParams.merchantName" placeholder="请输入商户名称" allow-clear @pressEnter="handleQuery" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮 -->
      <div class="table-operator" style="margin-bottom: 16px">
        <a-button type="primary" icon="plus" @click="handleAdd">新增商户配置</a-button>
        <a-button icon="sync" @click="handleRefresh">刷新配置</a-button>
      </div>
      <!-- 表格 -->
      <a-table
        :columns="columns"
        :data-source="data"
        rowKey="id"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template slot="status" slot-scope="text, record">
          <a-switch
            :checked="text === 1"
            @change="(checked) => handleStatusChange(checked, record)"
            checked-children="开"
            un-checked-children="关"
          />
        </template>
        <template slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定要删除该商户配置吗？" @confirm="handleDelete(record)">
            <a style="color: #ff4d4f">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>

    <!-- 新增/编辑弹窗 -->
    <a-modal
      :visible="modalVisible"
      :title="modalTitle"
      @cancel="closeModal"
      :maskClosable="false"
      :footer="null"
      width="800px"
    >
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="微信商户号" prop="mchId">
          <a-input v-model="form.mchId" placeholder="微信支付商户号(mch_id)" />
        </a-form-model-item>
        <a-form-model-item label="微信AppId" prop="appId">
          <a-input v-model="form.appId" placeholder="微信AppId" />
        </a-form-model-item>
        <a-form-model-item label="小程序AppId" prop="xcxAppId">
          <a-input v-model="form.xcxAppId" placeholder="小程序AppId" />
        </a-form-model-item>
        <a-form-model-item label="商户名称" prop="merchantName">
          <a-input v-model="form.merchantName" placeholder="商户名称" />
        </a-form-model-item>
        <a-form-model-item label="APIv3密钥" prop="apiV3Key">
          <a-input-password v-model="form.apiV3Key" placeholder="APIv3密钥" />
        </a-form-model-item>
        <a-form-model-item label="APIv2密钥" prop="mchKey">
          <a-input-password v-model="form.mchKey" placeholder="APIv2密钥" />
        </a-form-model-item>
        <a-form-model-item label="证书序列号" prop="certSerialNo">
          <a-input v-model="form.certSerialNo" placeholder="商户证书序列号" />
        </a-form-model-item>
        <a-form-model-item label="私钥文件" prop="privateKeyPath">
          <a-upload :file-list="privateKeyFileList" :remove="() => removeCertFile('privateKeyPath', privateKeyFileList)"
                    :customRequest="(opt) => uploadCertFile(opt, 'privateKeyPath', privateKeyFileList)" :multiple="false" :show-upload-list="false">
            <a-button :loading="uploading === 'privateKeyPath'"><a-icon type="upload" />选择私钥文件</a-button>
          </a-upload>
          <div v-if="form.privateKeyPath" class="cert-file-info">
            <a-icon type="file-text" style="color: #1890ff; margin-right: 4px;" />
            <span>{{ form.privateKeyPath.split('/').pop() }}</span>
            <a-icon type="close-circle" style="color: #ff4d4f; margin-left: 6px; cursor: pointer;" @click="removeCertFile('privateKeyPath', privateKeyFileList)" />
          </div>
        </a-form-model-item>
        <a-form-model-item label="证书文件" prop="privateCertPath">
          <a-upload :file-list="privateCertFileList" :remove="() => removeCertFile('privateCertPath', privateCertFileList)"
                    :customRequest="(opt) => uploadCertFile(opt, 'privateCertPath', privateCertFileList)" :multiple="false" :show-upload-list="false">
            <a-button :loading="uploading === 'privateCertPath'"><a-icon type="upload" />选择证书文件</a-button>
          </a-upload>
          <div v-if="form.privateCertPath" class="cert-file-info">
            <a-icon type="file-text" style="color: #1890ff; margin-right: 4px;" />
            <span>{{ form.privateCertPath.split('/').pop() }}</span>
            <a-icon type="close-circle" style="color: #ff4d4f; margin-left: 6px; cursor: pointer;" @click="removeCertFile('privateCertPath', privateCertFileList)" />
          </div>
        </a-form-model-item>
        <a-form-model-item label="微信公钥ID" prop="publicKeyId">
          <a-input v-model="form.publicKeyId" placeholder="微信公钥ID" />
        </a-form-model-item>
        <a-form-model-item label="微信公钥路径" prop="publicKeyPath">
          <a-upload :file-list="publicKeyFileList" :remove="() => removeCertFile('publicKeyPath', publicKeyFileList)"
                    :customRequest="(opt) => uploadCertFile(opt, 'publicKeyPath', publicKeyFileList)" :multiple="false" :show-upload-list="false">
            <a-button :loading="uploading === 'publicKeyPath'"><a-icon type="upload" />选择公钥文件</a-button>
          </a-upload>
          <div v-if="form.publicKeyPath" class="cert-file-info">
            <a-icon type="file-text" style="color: #1890ff; margin-right: 4px;" />
            <span>{{ form.publicKeyPath.split('/').pop() }}</span>
            <a-icon type="close-circle" style="color: #ff4d4f; margin-left: 6px; cursor: pointer;" @click="removeCertFile('publicKeyPath', publicKeyFileList)" />
          </div>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-switch v-model="form.statusChecked" checked-children="启用" un-checked-children="禁用" />
        </a-form-model-item>
        <div style="text-align: center; border-top: 1px solid #e8e8e8; padding-top: 16px;">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="handleSubmit">确定</a-button>
            <a-button @click="closeModal">取消</a-button>
          </a-space>
        </div>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import * as api from '@/api/pay/wxMerchantConfig'
import { generateFilePath, uploadObject } from '@/api/tool/oss'

export default {
  name: 'WxMerchantConfig',
  data() {
    return {
      data: [],
      loading: false,
      submitLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        mchId: '',
        merchantName: ''
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      columns: [
        { title: '微信商户号', dataIndex: 'mchId', width: 160 },
        { title: '商户名称', dataIndex: 'merchantName', width: 150 },
        { title: 'AppId', dataIndex: 'appId', width: 180 },
        { title: '证书序列号', dataIndex: 'certSerialNo', width: 120, ellipsis: true },
        { title: '状态', dataIndex: 'status', width: 80, scopedSlots: { customRender: 'status' } },
        { title: '创建时间', dataIndex: 'createTime', width: 170 },
        { title: '操作', dataIndex: 'action', width: 120, fixed: 'right', scopedSlots: { customRender: 'action' } }
      ],
      modalVisible: false,
      modalTitle: '',
      editId: null,
      form: {
        mchId: '',
        appId: '',
        xcxAppId: '',
        merchantName: '',
        apiV3Key: '',
        mchKey: '',
        certSerialNo: '',
        privateKeyPath: '',
        privateCertPath: '',
        publicKeyId: '',
        publicKeyPath: '',
        status: 1,
        statusChecked: true
      },
      privateKeyFileList: [],
      privateCertFileList: [],
      publicKeyFileList: [],
      uploading: '',
      rules: {
        mchId: [{ required: true, message: '请输入微信商户号', trigger: 'blur' }],
        appId: [{ required: true, message: '请输入微信AppId', trigger: 'blur' }],
        merchantName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
        apiV3Key: [{ required: true, message: '请输入APIv3密钥', trigger: 'blur' }],
        xcxAppId: [{ required: true, message: '请输入小程序appId', trigger: 'blur' }],
        certSerialNo: [{ required: true, message: '请输入证书序列号', trigger: 'blur' }],
        privateKeyPath: [{ required: true, message: '请输入私钥文件路径', trigger: 'blur' }],
        publicKeyId: [{ required: true, message: '请输入微信公钥ID', trigger: 'blur' }],
        publicKeyPath: [{ required: true, message: '请输入微信公钥路径', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        privateCertPath: [{ required: true, message: '请输入证书文件路径', trigger: 'change' }],
        mchKey: [{ required: true, message: '请输入APIv2密钥', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      api.pageList(this.queryParams).then(res => {
        if (res.code == 20001 && res.data) {
          this.data = res.data.records || []
          this.pagination.total = res.data.total || 0
        }
      }).finally(() => { this.loading = false })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = { pageNum: 1, pageSize: 10, mchId: '', merchantName: '' }
      this.handleQuery()
    },
    handleTableChange(pagination) {
      this.queryParams.pageNum = pagination.current
      this.queryParams.pageSize = pagination.pageSize
      this.getList()
    },
    handleAdd() {
      this.editId = null
      this.modalTitle = '新增微信支付商户配置'
      this.resetForm()
      this.modalVisible = true
    },
    handleEdit(record) {
      this.editId = record.id
      this.modalTitle = '编辑微信支付商户配置'
      this.form = { ...record }
      this.form.statusChecked = record.status === 1
      // 编辑时回显已上传的文件
      if (record.privateKeyPath) {
        this.privateKeyFileList = [{ uid: '-1', name: record.privateKeyPath.split('/').pop(), status: 'done', url: record.privateKeyPath }]
      }
      if (record.privateCertPath) {
        this.privateCertFileList = [{ uid: '-2', name: record.privateCertPath.split('/').pop(), status: 'done', url: record.privateCertPath }]
      }
      if (record.publicKeyPath) {
        this.publicKeyFileList = [{ uid: '-3', name: record.publicKeyPath.split('/').pop(), status: 'done', url: record.publicKeyPath }]
      }
      this.modalVisible = true
    },
    handleDelete(record) {
      api.del({ id: record.id }).then(res => {
        if (res.code == 20001) {
          this.$message.success('删除成功')
          this.getList()
        }
      })
    },
    handleStatusChange(checked, record) {
      const status = checked ? 1 : 0
      api.updateStatus({ id: record.id, status }).then(res => {
        if (res.code == 20001) {
          record.status = status
          this.$message.success(checked ? '已启用' : '已禁用')
        }
      })
    },
    handleRefresh() {
      api.refreshConfig().then(res => {
        if (res.code == 20001) {
          this.$message.success(res.msg || '配置刷新成功')
        }
      })
    },
    removeCertFile(field, fileList) {
      fileList.splice(0, fileList.length)
      this.form[field] = ''
      return true
    },
    uploadCertFile(opt, field, fileList) {
      this.uploading = field
      const filePath = generateFilePath('cert', opt.file.name.substring(opt.file.name.lastIndexOf('.')))
      uploadObject(filePath, opt.file).then(ossUrl => {
        if (ossUrl) {
          this.form[field] = ossUrl
          fileList.splice(0, fileList.length, { uid: opt.file.uid, name: opt.file.name, status: 'done', url: ossUrl })
          this.$message.success(`${opt.file.name} 上传成功`)
        } else {
          this.$message.error(`${opt.file.name} 上传失败`)
        }
      }).catch(() => {
        this.$message.error(`${opt.file.name} 上传失败`)
      }).finally(() => {
        this.uploading = ''
        opt.onSuccess && opt.onSuccess()
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const params = { ...this.form }
        params.status = params.statusChecked ? 1 : 0
        delete params.statusChecked

        const request = this.editId ? api.update(params) : api.create(params)
        request.then(res => {
          if (res.code == 20001) {
            this.$message.success(this.editId ? '修改成功' : '新增成功')
            this.closeModal()
            this.getList()
          }
        }).finally(() => { this.submitLoading = false })
      })
    },
    closeModal() {
      this.modalVisible = false
      this.resetForm()
    },
    resetForm() {
      this.form = {
        mchId: '', appId: '', xcxAppId: '', merchantName: '',
        apiV3Key: '', mchKey: '', certSerialNo: '',
        privateKeyPath: '', privateCertPath: '',
        publicKeyId: '', publicKeyPath: '',
        status: 1, statusChecked: true
      }
      this.privateKeyFileList = []
      this.privateCertFileList = []
      this.publicKeyFileList = []
      this.uploading = ''
      this.$nextTick(() => { this.$refs.form?.clearValidate() })
    }
  }
}
</script>

<style scoped>
.table-operator {
  display: flex;
  gap: 8px;
}
.cert-file-info {
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
  padding: 4px 10px;
  background: #f0f5ff;
  border: 1px solid #d6e4ff;
  border-radius: 4px;
  font-size: 13px;
}
</style>
